import React from 'react';

const Logo = props => (
    <img height="50px" alt="Synamedia" src="https://vdcm.info/synamedia.png" />
);


export default Logo;